import { Helmet } from 'react-helmet';
import { Header } from '../../../../Components/Header';
import { Container, useMediaQuery, useTheme } from '@mui/material';
import Footer from '../../../../Components/Footer';
import PageLiveDoArena251 from './components/pages/PageLiveDoArea251';

export default function LiveDoArena251() {
	const theme = useTheme();
	const matchesMobile = useMediaQuery(theme.breakpoints.down('sm'));
	const matchesTablet = useMediaQuery(theme.breakpoints.down('md'));

	return (
		<Container
			maxWidth={false}
			disableGutters={true}
			style={{ backgroundColor: '#060502', minHeight: '100vh' }}
		>
			<Helmet>
				<title>Live dos Imbatíveis - Arena - Hardwork</title>
				<meta
					name="description"
					content={''}
				/>
			</Helmet>
			{matchesMobile ? null : matchesTablet ? <Header /> : null}
			<Container
				fixed
				maxWidth="xl"
				disableGutters={true}
				className="residencia"
			>
				{matchesMobile || matchesTablet ? null : <Header />}
			</Container>

			<PageLiveDoArena251 />

			<Container
				fixed
				maxWidth="xl"
				disableGutters={true}
			>
				{matchesTablet ? null : <Footer />}
			</Container>
			{matchesTablet ? <Footer /> : null}
		</Container>
	);
}
